@if (dropdownLabel) {
  <label class="trim-text">{{ dropdownLabel }}
    @if (errors?.['required']) {
      <small>*</small>
    }
  </label>
}
<ng-container *transloco="let t">
    <app-dropdown (openChange)="multiselectDropdownOpenChange($event)" [removeArrow]="isButton"
                  [disabled]="disabled" [isDropdownListFullWidth]="isDropdownListFullWidth">
      <div dropdownPanel>
        @if (!isButton) {
        <div class="panel expandable" dropdownToggle [class.error]="touched && invalid" [class.disabled]="disabled">
              <div class="d-flex align-items-center">
                @if (formControlValue.length > 0) {
                <div class="mt-1 d-flex align-items-center flex-row flex-wrap">
                @for (item of (maxItemsDisplay ? selectedValues.slice(0, maxItemsDisplay) : selectedValues); track item) {
                    <div class="my-1">
                        <app-badge-with-button
                        [badgeText]="getOptionLabel(item)"
                        [item]="item"
                        (buttonAction)="onItemSelect(item)" />
                    </div>
                }

                @if (maxItemsDisplay && selectedValues.length > maxItemsDisplay) {
                    <div class="my-1">
                         <span>
                            +{{ selectedValues.length - maxItemsDisplay }}
                        </span>
                    </div>
                }
                </div>
                }
          </div>
        </div>
        }
          @else {
          <span class="menu-icon" [class.icon-table-heading]="isTableHeading" [ngClass]="iconClass" dropdownToggle>
             <ng-container *ngIf="buttonIconClass?.endsWith('.svg'); else fontIcon">
               <img [src]="buttonIconClass" [ngStyle]="{ width: iconSize + 'px', height: iconSize + 'px' }" class="cursor-pointer"
              alt="icon"
            />
          </ng-container>
          <ng-template #fontIcon>
            <i
              [class]="buttonIconClass ?? 'fas fa-ellipsis-v'"
              [ngStyle]="{ fontSize: iconSize + 'px' }"
            ></i>
          </ng-template>
        </span>
          }
      </div>
      <div dropdownContent id="multiselectDropdown">
        <ng-container [ngTemplateOutlet]="content">
        </ng-container>
      </div>
    </app-dropdown>

    @if (invalid && touched) {
      @for (errorMessage of errors | errorMessages;track errorMessage) {
        <span class="errorMes pt-1">{{ errorMessage }} </span>
      }
  }
  <ng-template #content>
      @if (options.size > SEARCH_ELEMENT_BREAKPOINT) {
      <div class="search-wrapper">
          <i class="bi bi-search ps-1"></i>
          <input [placeholder]="t('explore.search')" class="search-input ps-2 d-flex"
            [ngModel]="searchText" (ngModelChange)="onSearch($event)"/>
      </div>
      }
    <div class="dropdown-list-wrapper">
      @if (!maxItemsCount && !searchText?.length) {
        <div (click)="onSelectAll()" class="select-item">
            <input type="checkbox" [checked]="options && options.size === formControlValue.length"/>
            <span class="option-label">{{ t("app.common.all") | titlecase }}</span>
        </div>
      } @else if (maxItemsCount && ((maxItemsCount ?? 0) < (options.size ?? 0))) {
        <div class="p-2">
          <span> {{ t("multiselect.max.item", {value: maxItemsCount}) }}</span>
        </div>
      }
      @if (filteredOptions.size) {
      @for (item of filteredOptions.keys();track item) {
        <div (click)="onItemSelect(item)" class="select-item">
            <input type="checkbox" [checked]="isOptionSelected(item)"/>
            <span class="option-label">{{ getOptionLabel(item) }}</span>
        </div>
      }}
      @else {
        <span class="empty-list">
        {{ t("emptyState.not.able.to.find") }}
        </span>
      }
    </div>
  </ng-template>
</ng-container>
